<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          heading="Список таблиц"
        />
        <base-material-card
          color="primary"
          icon="mdi-file-document"
          inline
        >
          <template v-slot:after-heading>
            <div class="text-h3 font-weight-light">
              Таблицы
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search.sync="search"
              multi-sort
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.id"
                          label="Идентификатор"
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.name"
                          label="Название"
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox
                          v-model="form.all"
                          label="Показывать удаленные"
                          @change="load"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          @click="load"
                        >
                          Поиск
                        </v-btn>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="secondary"
                          dark
                          min-width="250"
                          class="mb-2"
                          @click="clear"
                        >
                          Сбросить фильтры
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  v-if="!item.readonly && ($store.state.access[8][3] || $store.state.access[8][4] && item.creator && item.creator.id == $store.state.user.id)"
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/table/view?id=' + item.id)"
                >
                  mdi-cog
                </v-icon>
                <v-icon
                  v-else
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/table/view?id=' + item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <template v-slot:item.date="{ item }">
                {{ format_date(item.date) }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="$store.state.access[8][5]"
              color="primary"
              min-width="100"
              @click="$router.push('/table/create')"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      sheet: false,
      sheetmenu: true,
      headers: [
        {
          sortable: false,
          text: 'Действия',
          value: 'action',
        },
        {
          text: 'Название',
          value: 'name',
        },
        {
          text: 'Описание',
          value: 'description',
        },
      ],
      items: [],
      form: {
      },
      select: {
      },
      dict: {
      },
    }),
    mounted: function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      this.load()
    },
    methods: {
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function () {
        this.axios.post('/api/table/list', this.form)
          .then(result => {
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
